<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
  <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">{{ inputData.title }}</h2>
  <button mat-icon-button mat-dialog-close (click)="resetForm()" aria-label="Fermer">
    <mat-icon class="text-muted">close</mat-icon>
  </button>
</div>

<mat-dialog-content [formGroup]="siteForm" class="p-4 bg-white custom-dialog-content">
  <div class="d-flex flex-column gap-1">

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Bureau</mat-label>
      <input matInput type="text" formControlName="name" placeholder="Entrez le nom du bureau">
      @if (siteForm.get('name')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Groupe</mat-label>
      <mat-select formControlName="groupe_id">
        @for (item of groupes; track $index) {
          <mat-option [value]="item.id">{{ item.name }}</mat-option>
        }
      </mat-select>
      @if (siteForm.get('groupe')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Proprietaire</mat-label>
      <input matInput type="text" formControlName="owner" placeholder="Entrez le nom du proprietaire">
      @if (siteForm.get('owner')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Adresse</mat-label>
      <input matInput type="text" formControlName="adresse" placeholder="Entrez le nom du proprietaire">
      @if (siteForm.get('adresse')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
    </mat-form-field>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-light m-0 gap-2">
  <button mat-stroked-button mat-dialog-close color="warn" class="px-4" (click)="resetForm()">Fermer</button>
  
  @if (inputData.update) {
    <button [disabled]="siteForm.invalid" mat-flat-button color="primary" class="px-4" (click)="onUpdate()">Modifier</button>
  } @else {
    <button [disabled]="siteForm.invalid" mat-flat-button color="primary" class="px-4" (click)="onAdd()">Enregistrer</button>
  }
</mat-dialog-actions>
